<template>

<v-dialog v-model="dialog" width="90vw">
  <v-card>
    <p class=".title ma-2">Ledger mutations - Sales Partner: {{hsprHpgm.inpt_code}} {{hsprHpgm.inpt_naam}}</p>
    <v-form ref="showHsprHpgm">
       

       <v-simple-table dense>
                    <template v-slot:default>
                      <thead>
                          <tr>
                            <td><span class="10px font-weight-light">Date / Time</span></td>
                            <td><span class="10px font-weight-light">Description</span></td>
                            <td align="right"><span class="10px font-weight-light">Deb</span></td>
                            <td align="right"><span class="10px font-weight-light">Cred</span></td>
                            <td align="right"><span class="10px font-weight-light">Amount</span></td>
                            <td align="right"><span class="10px font-weight-light">Payment</span></td>
                          </tr>  
                        </thead>
                        

                        <tbody v-for="(hsprRecord,k1) in hsprHpgm.hspr" :key="k1">
                          <tr>
                            <td> {{hsprRecord.hspr_dt}} </td>
                            <td>{{hsprRecord.fctitaal_oms}}</td>
                            <td></td>
                            <td></td>
                            <td align="right">{{hsprRecord.hspr_line }}</td>
                            <td align="right">{{hsprRecord.hspr_payment }}</td>
                          </tr>
                          <tr v-for="(hpgmRecord,k2) in hsprRecord.hpgm" :key="k2">
                            <td><span class="mx-2">{{hpgmRecord.hpgm_datum}}</span></td>
                            <td><span class="mx-3">{{hpgmRecord.gbrk_nr}} - {{hpgmRecord.gbrk_oms}}</span></td>
                            <td align="right">{{hpgmRecord.hpgm_deb}}</td>
                            <td align="right">{{hpgmRecord.hpgm_cred}}</td>
                          </tr>  
                        </tbody>  

                    </template>  
                  </v-simple-table>
       

    </v-form>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary"  small @click="dialog = false">Close</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>
export default {
  data() { 
    return {
      dialog: false,
      huov_encrid: null,
      hsprHpgm: {}
    }
  },
  methods: {
    open(huov_encrid, hpgm_boek_verblijf) {
      this.$emit("showSnackbar");
      this.dialog = true;
      this.huov_encrid = huov_encrid;
      this.$axios
        .post("ares/json/ares/huov/hspr/hpgm/getHsprHpgm.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getHsprHpgm"
          },
          getHsprHpgm: {
            huov_encrid: huov_encrid,
            hpgm_boek_verblijf: hpgm_boek_verblijf
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.hsprHpgm = res.data.getHsprHpgm;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
}
</script>

